import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { HuduExport } from 'DiscoveryEngine.TS/Export/HuduExport';
import { HuduExportConfigComponent } from '../hudu-export-config/hudu-export-config.component';

@Component({
	selector: 'sched-disc-config-hudu',
	templateUrl: './sched-disc-config-hudu.component.html',
	styleUrls: ['./sched-disc-config-hudu.component.scss']
})
export class SchedDiscConfigHuduComponent extends SchedDiscConfigComponentBase {

	@ViewChild(HuduExportConfigComponent, { static: true })
	private HuduExportComp: HuduExportConfigComponent;

	private static NullHuduExport = new HuduExport();

	public get HuduExport(): HuduExport {
		if (this.Discovery)
			return this.Discovery.HuduExport;
		else
			return SchedDiscConfigHuduComponent.NullHuduExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.HuduExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.HuduExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.HuduExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.HuduExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.HuduExportComp.discardTempChanges();
	}

}
